// extracted by mini-css-extract-plugin
export var actionButton = "_r2-0";
export var actionMenuContainer = "_r2-i";
export var bubble = "_r2-2";
export var bubbleActionMenu = "_r2-j";
export var bubbleContext = "_r2-6";
export var bubbleItems = "_r2-7";
export var customer = "_r2-3";
export var divider = "_r2-8";
export var fileList = "_r2-9";
export var hiddenComment = "_r2-o";
export var infoAbove = "_r2-a";
export var internal = "_r2-4";
export var lightActionButton = "_r2-1";
export var link = "_r2-b";
export var merchant = "_r2-5";
export var message = "_r2-c";
export var profilePicture = "_r2-e";
export var quillToolbarContainer = "_r2-f";
export var senderDate = "_r2-g";
export var senderDateCustomer = "_r2-h";
export var senderName = "_r2-d";
export var time = "_r2-k";
export var uploadedImage = "_r2-l";
export var username = "_r2-m";
export var xsmall = "_r2-n";